import { EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LeagueEventEmitters {
  public leagueChangedEvent = new EventEmitter();
}